// Formattazione data/ora condivisa fra partnerPortalAccessHelpers.ts e
// collaboratorAccessHelpers.ts (era la stessa implementazione di `formatLastAccess`
// duplicata identica nei due file).

export function formatPortalDateTime(value: string): string {
  return new Date(value).toLocaleString('it-IT', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatLastAccess(value?: string): string {
  return value ? formatPortalDateTime(value) : 'Mai';
}
